import React from "react";
import AdminLayout from "./AdminLayout";

import ActivationCodesManagement from "./ActivationCodesManagement";


function ActivationCodes() {
    return (
        <AdminLayout>
            <ActivationCodesManagement />
        </AdminLayout>
    );
}

export default ActivationCodes;
